import { render, staticRenderFns } from "./AddContractor.vue?vue&type=template&id=6cc50dd0"
import script from "./AddContractor.vue?vue&type=script&lang=js"
export * from "./AddContractor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports